<template>
  <div class="galaxy-detail-page" ref="pageRef" @scroll="onPageScroll" v-bind="$attrs">
    <section class="overview-card">
      <!-- <div class="overview-left">
        <div class="device-image-wrap">
          <img :src="imageSrc" alt="Galaxy设备图" class="device-image" loading="lazy" />
        </div>
      </div> -->
      <div class="overview-right">
        <div class="header-card">
          <div class="header-left">
            <v-btn icon variant="flat" color="#2F59EB" @click="onBack">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <div class="header-main">
              <h2 class="device-name">{{ galaxy.equipmentName }}</h2>
              <div class="meta-row">
                <span>型号：{{ galaxy.productModel }}</span>
                <span>设备编号：{{ galaxy.id }}</span>
                <span class="d-flex align-center flex-wrap">UUID：{{ galaxy.uuid }}
                  <v-btn v-if="galaxy.uuid" class="ml-1" size="x-small" variant="text" rounded="pill"
                    color="var(--color-success)" @click.stop="copyUuid(galaxy.uuid)">复制</v-btn>
                </span>
              </div>
            </div>
          </div>

          <div class="header-right">
            <div class="status-item">
              <v-chip size="small" class="status-alarm" :class="realData?.alarm_count > 0 ? 'is-alarm' : 'is-normal'">
                <Siren size="16" />{{ realData?.alarm_count > 0 ? `告警(${realData?.alarm_count})` : '无告警' }}
              </v-chip>
            </div>
            <div class="status-item">
              <v-chip size="small" class="status-pill" :class="realData?.is_online ? 'online' : 'offline'">
                <Wifi size="16" />
                <span>{{ realData?.is_online ? '在线' : '离线' }}</span>
              </v-chip>
            </div>
          </div>
        </div>

        <v-divider color="var(--color-td-border)" opacity="1" class="my-4"></v-divider>

        <div class="d-flex">
          <div class="overview-left">
            <div class="device-image-wrap">
              <img :src="imageSrc" alt="Galaxy设备图" class="device-image" loading="lazy" />
            </div>
          </div>
          <section class="data-section overview-section">
            <div class="section-title">
              <div class="section-title-left">
                <v-icon size="16" color="#62C282">mdi-checkbox-marked-circle-outline</v-icon>
                <span>状态总览</span>
              </div>
            </div>
            <div class="overview-grid">
              <DataCard class="blue-bg blue-border pa-4 flex-row-reverse" title="工作状态" title-position="top"
                :value="ELinkRunSt.getText(realData.eLink?.run_st)" unit=""
                :value-style="{ fontSize: '16px', fontWeight: 700 }">
                <template #icon>
                  <img src="./img/ic_work_status.png" alt="ic_work_status">
                </template>
              </DataCard>
              <DataCard class="blue-bg blue-border pa-4 flex-row-reverse" title="实时功率" title-position="top"
                :value="toFixedDisplay(realData.eLink?.p_total, 2)" unit="kW"
                :value-style="{ fontSize: '16px', fontWeight: 700 }" />
              <DataCard class="red-bg red-border pa-4 flex-row-reverse" title="SOC" title-position="top"
                :value="toFixedDisplay(realData.eLink?.soc, 2)" unit="%"
                :value-style="{ fontSize: '16px', fontWeight: 700 }">
                <template #icon>
                  <v-progress-circular :model-value="Number(realData.eLink?.soc) || 0" :rotate="180" :size="50"
                    :width="4" color="pink">
                    <span style="font-size: 12px; font-weight: 700;">{{ toFixedDisplay(realData.eLink?.soc, 2) }}</span>
                  </v-progress-circular>
                </template>
              </DataCard>
              <DataCard class="blue-bg blue-border pa-4 flex-row-reverse" title="SOH" title-position="top"
                :value="appraiseFromSOH(realData.eBlock?.soh)" unit=""
                :value-style="{ fontSize: '16px', fontWeight: 700 }">
                <template #icon>
                  <img src="./img/ic_soh.png" alt="ic_soh">
                </template>
              </DataCard>
              <DataCard class="green-bg green-border pa-4 flex-row-reverse" title="电池剩余电量" title-position="top"
                :value="toFixedDisplay(realData.eLink?.e_dischargeable, 2)" unit="kWh"
                :value-style="{ fontSize: '16px', fontWeight: 700 }">
                <template #icon>
                  <BatteryIcon :soc="realData.eLink?.soc" />
                </template>
              </DataCard>
            </div>
          </section>
        </div>
      </div>
    </section>

    <section class="content-card">
      <DataCardPropProvide :value-style="{ fontSize: '14px', fontWeight: '700' }">

        <div class="side-nav-wrapper">
          <aside class="side-nav">
            <div v-for="item in sideMenus" :key="item.key" class="side-nav-item"
              :class="{ active: activeSection === item.key }" @click="onSideNavClick(item)">
              <v-icon size="18">{{ item.icon }}</v-icon>
              <span>{{ item.label }}</span>
            </div>
          </aside>
        </div>

        <div class="detail-sections">
          <section class="data-section" id="data-section-elink">
            <div class="section-head">
              <div class="section-head-title">
                <v-icon size="16" color="#62c282">mdi-link-variant</v-icon>
                <span>eLink</span>
                <span style="font-size: 12px; color: #999;" class="d-flex align-center flex-wrap">{{ eLink.uuid }}
                  <v-btn v-if="eLink.uuid" class="ml-1" size="x-small" variant="text" rounded="pill"
                    color="var(--color-success)" @click.stop="copyUuid(eLink.uuid)">复制</v-btn>
                </span>
              </div>
              <button type="button" class="section-more-btn" @click="openElinkDetail">详情 <v-icon
                  size="14">mdi-chevron-right</v-icon></button>
            </div>
            <div class="section-grid">
              <DataCard class="kv-bg" v-for="item in eLinkItems" :key="item.key" :title="item.label"
                title-position="left" :value="item.value" :unit="item.unit" />
            </div>
          </section>

          <section class="data-section" id="data-section-pcs">
            <div class="section-head">
              <div class="section-head-title">
                <v-icon size="16" color="#4c7eff">mdi-cog-outline</v-icon>
                <span>PCS</span>
              </div>
              <button type="button" class="section-more-btn" @click="openPCSDetail">详情 <v-icon
                  size="14">mdi-chevron-right</v-icon></button>
            </div>
            <div class="tabs">
              <button v-for="(tab, index) in pcsTabs" :key="tab" class="tab" :class="{ active: activePcsTab === tab }"
                @click="onPcsTabClick(tab, index)">
                {{ tab }}
              </button>
            </div>
            <div class="section-grid">
              <DataCard class="kv-bg" v-for="item in pcsItems" :key="item.key" :title="item.label" title-position="left"
                :value="item.value" :unit="item.unit" />
            </div>
          </section>

          <section class="data-section" id="data-section-battery">
            <div class="section-head">
              <div class="section-head-title">
                <v-icon size="16" color="#60cf87">mdi-battery-high</v-icon>
                <span>电池簇</span>
              </div>
              <button type="button" class="section-more-btn" @click="openClusterDetail">详情 <v-icon
                  size="14">mdi-chevron-right</v-icon></button>
            </div>
            <div class="tabs">
              <button v-for="(tab, index) in batteryTabs" :key="tab" class="tab"
                :class="{ active: activeBatteryTab === tab }" @click="onBatteryClusterTabClick(tab, index)">
                {{ tab }}
              </button>
            </div>
            <div class="section-grid">
              <DataCard class="kv-bg" v-for="item in batteryItems" :key="item.key" :title="item.label"
                title-position="left" :value="item.value" :unit="item.unit" />
            </div>
          </section>

          <section class="data-section" id="data-section-fire">
            <div class="section-head">
              <div class="section-head-title">
                <v-icon size="16" color="#ff9850">mdi-fire</v-icon>
                <span>消防</span>
              </div>
              <button type="button" class="section-more-btn" @click="openFireDetail">详情 <v-icon
                  size="14">mdi-chevron-right</v-icon></button>
            </div>
            <div class="section-grid">
              <DataCard class="kv-bg" v-for="item in fireItems" :key="item.key" :title="item.label"
                title-position="left" :value="item.value" :unit="item.unit" />
            </div>
          </section>

          <section class="data-section" id="data-section-air">
            <div class="section-head">
              <div class="section-head-title">
                <v-icon size="16" color="#4c7eff">mdi-air-conditioner</v-icon>
                <span>空调/水机</span>
              </div>
              <button type="button" class="section-more-btn" @click="openAirConditionDetail">详情 <v-icon
                  size="14">mdi-chevron-right</v-icon></button>
            </div>
            <div class="section-grid">
              <DataCard class="kv-bg" v-for="item in airItems" :key="item.key" :title="item.label" title-position="left"
                :value="item.value" :unit="item.unit" />
            </div>
          </section>
        </div>
      </DataCardPropProvide>
    </section>
  </div>

  <!-- eLink 详情弹框 -->
  <ElinkDetailDialog v-model="eLinkDetailDialogVisible" :elink="eLinkDialogData" />

  <PcsDetailDialog v-model="pcsDetailDialogVisible" :block-data="currentPcsDetail" :real-data="pcsRealData?.[0]" />
  <!-- Cluster 详情弹框 -->
  <ClusterDetailDialog v-model="clusterDetailDialogVisible" :cluster-data="currentClusterDetail"
    :eblock-id="currentClusterDetail?.eblock_id || currentClusterDetail?.id" />

  <!-- Pack 详情弹框 (新组件) -->
  <FirePackDetailDialog v-model="packDialogVisible" :block="currentBlock" />

  <!-- 空调详情 -->
  <AirConditionDetailDialog v-model="airConditionDetailVisible" :stationId="props.stationId"
    :elinkUuid="currentDetailElinkUuid" :eblockUuid="currentDetailEblockUuid"
    :openAlarmHistory="openWithAlarmHistory" />
</template>

<script setup>
import { computed, nextTick, onBeforeUnmount, onMounted, onUnmounted, ref, useTemplateRef, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import DataCard from '@/components/DataCard/index.vue'
import DataCardPropProvide from '@/components/DataCard/PropProvide.vue'
import BatteryIcon from './img/Battery.vue'
import blockMainGalaxy from '@/assets/images/station-monitor/detail-dialog/block-main-galaxy.png'
import { Siren, Wifi } from 'lucide-vue-next'
import { ws_req } from '@/ws/wss-request'
import { useRealData } from '@/hooks/useRealData'
import { createStatusMap } from '@/utils'
import { appraiseFromSOH } from '@/views/station-monitor/detail/components/real-time-monitor/monitorEnums'
import useAppStore from '@/store/modules/app'
import { eui } from 'ems-ui'

import PcsDetailDialog from '../../../components/real-time-monitor/PcsDetailDialog.vue'
import ElinkDetailDialog from '../../../components/real-time-monitor/ElinkDetailDialog.vue'
import ClusterDetailDialog from '../../../components/real-time-monitor/ClusterDetailDialog.vue'
import FirePackDetailDialog from '../../../components/real-time-monitor/FirePackDetailDialog.vue'
import AirConditionDetailDialog from '../../../components/real-time-monitor/AirConditionDetailDialog.vue'

const pcsDetailDialogVisible = ref(false)
const clusterDetailDialogVisible = ref(false)
const packDialogVisible = ref(false)
const airConditionDetailVisible = ref(false)
const eLinkDetailDialogVisible = ref(false)
const currentPcsDetail = ref(null)
const currentClusterDetail = ref(null)
const currentBlock = ref(null)
const currentDetailElinkUuid = ref(null)
const currentDetailEblockUuid = ref(null)
const openWithAlarmHistory = ref(false)


const appStore = useAppStore()
const route = useRoute()
const router = useRouter()

function copyUuid(uuid) {
  if (uuid === undefined || uuid === null || uuid === '') return
  navigator.clipboard.writeText(String(uuid))
  eui.showToast('复制成功', 'success')
}

// 
const props = defineProps({
  stationId: {
    type: [String, Number],
    required: true
  },
  galaxy: {
    type: Object,
    default: () => ({})
  },
  eLink: {
    type: Object,
    default: () => ({})
  }
})

const station = computed(() => appStore.getStationById(props.stationId))
const isGalaxy1_2G = computed(() => station.value?.equipmentModel?.includes('eBlock-Galaxy-1-2G') || false)
const firstEBlock = computed(() => props.eLink?.eBlocks?.[0] || {})
const eBlockDialogUuid = computed(() => firstEBlock.value?.uuid || props.galaxy?.uuid || null)
const eLinkDialogData = computed(() => ({
  ...props.eLink,
  name: props.eLink?.eLinkName || props.eLink?.name || 'eLink',
  model: props.eLink?.productModel || station.value?.equipmentModel || '--',
  uuid: props.eLink?.uuid || realData.value?.eLink?.uuid || '--',
}))

const imageSrc = blockMainGalaxy

const headerInfo = ref({
  name: 'eBlock-Galaxy',
  model: 'eBlock-Galaxy-1',
  deviceNo: 'A1222',
  uuid: String(route.query.deviceId || 'AS1221123EB121212'),
  alarmCount: 2
})

const ELinkRunSt = createStatusMap({
  1: { text: '停机', color: 'var(--color-stopped)' },
  2: { text: '待机', color: 'var(--color-standby)' },
  3: { text: '充电', color: 'var(--color-charging)' },
  4: { text: '放电', color: 'var(--color-discharge)' },
})

const PowerOnSt = createStatusMap({
  0: { text: '关机' },
  1: { text: '开机' }
})

const BreakerSt = createStatusMap({
  0: { text: '断开' },
  1: { text: '闭合' }
})

const PcsRunSt = createStatusMap({
  0: { text: '停机' },
  1: { text: '自检' },
  2: { text: '待机' },
  3: { text: '并网' },
  6: { text: '故障' }
})

const PcsRunMode = createStatusMap({
  2: { text: '交流恒功率' },
  6: { text: '交流恒压' }
})

const FireSensorSt = createStatusMap({
  0: { text: '正常' },
  1: { text: '告警' }
})

const FireHostOnlineSt = createStatusMap({
  0: { text: '在线' },
  1: { text: '离线' }
})

const AircSt = createStatusMap({
  0: { text: '停机' },
  1: { text: '制热' },
  2: { text: '制冷' },
  3: { text: '故障' }
})

// eLink消防预警级别：正常/一级预警/二级预警/三级预警
const FireSt = createStatusMap({
  0: { text: '正常', color: '#00C853' },
  1: { text: '一级预警', color: '#F9A825' },
  2: { text: '二级预警', color: '#FF9100' },
  3: { text: '三级预警', color: '#D84315' },
})

const toFixedDisplay = (value, digits = 2, unit = '') => {
  if (value === null || value === undefined || value === '' || Number.isNaN(Number(value))) {
    return '--'
  }
  return `${Number(value).toFixed(digits)}${unit}`
}

const pickFirst = (...vals) => {
  for (const v of vals) {
    if (v !== undefined && v !== null && v !== '') return v
  }
  return undefined
}

const activeSection = ref('elink')
const sideMenus = [
  { key: 'elink', label: 'elink', icon: 'mdi-link' },
  { key: 'pcs', label: 'PCS', icon: 'mdi-cpu-64-bit' },
  { key: 'battery', label: '电池簇', icon: 'mdi-battery' },
  { key: 'fire', label: '消防', icon: 'mdi-fire' },
  { key: 'air', label: '空调/水机', icon: 'mdi-air-conditioner' }
]


const eLinkItems = computed(() => {
  const eLink = realData.value?.eLink || {}
  return [
    { key: 'pTotal', label: '总有功功率', value: eLink.p_total ?? '--', unit: 'kW' },
    { key: 'qTotal', label: '总无功功率', value: eLink.q_total ?? '--', unit: 'kW' },
    { key: 'pDischargeMax', label: '电池组最大可放电功率', value: eLink.p_disch_max ?? '--', unit: 'kW' },
    { key: 'pChargeMax', label: '电池组最大可充电功率', value: eLink.p_ch_max ?? '--', unit: 'kW' },
    { key: 'ia', label: '电网A相总电流', value: eLink.i_a ?? '--', unit: 'A' },
    { key: 'ib', label: '电网B相总电流', value: eLink.i_b ?? '--', unit: 'A' },
    { key: 'ic', label: '电网C相总电流', value: eLink.i_c ?? '--', unit: 'A' },
    { key: 'runSt', label: '系统运行状态', value: ELinkRunSt.getText(eLink.run_st) },
    { key: 'breaker', label: '断路器状态', value: BreakerSt.getText(eLink.ac_qf_st) },
    { key: 'switch', label: '开关状态', value: PowerOnSt.getText(eLink.power_on) }
  ]
})

const eBlocksLength = computed(() => props.eLink?.eBlocks?.length ?? 12)
const pcsTabs = Array.from({ length: eBlocksLength.value }).map((_, index) => `${index + 1}#PCS`)//['1#PCS', '2#PCS', '3#PCS', '4#PCS', '5#PCS', '6#PCS']
const activePcsTab = ref(pcsTabs[0])


let pcsIndex = ref(0)
const eBlockId = computed(() => props.eLink?.eBlocks?.at(pcsIndex.value)?.id)

// 监听电池簇ID变化，重新开始轮询
watch(() => eBlockId.value, (eblockId, _, onCleanup) => {
  if (eblockId) {
    pcsStart()
    onCleanup(() => {
      pcsStop()
    })
  }
})

const { realData: pcsRealData, start: pcsStart, stop: pcsStop, updateOnce: pcsUpdateOnce } = useRealData({
  interval: 2000,
  initData: [],
  immediate: false,
  updateFunction: () => {
    return ws_req.request('ws_eblock_pcs', {
      eBlockId: eBlockId.value,
      stationId: props.stationId
    })
  },
  onUpdate: (data) => {
    console.log('data--->', data);

  }
})


function onPcsTabClick(tab, index) {
  activePcsTab.value = tab

  // 设置当前PCS索引
  pcsIndex.value = index
}

const pcsItems = computed(() => {
  const pcs = pcsRealData.value?.[0]?.data || {}
  const eBlock = realData.value?.eBlock || {}
  return [
    { key: 'runSt', label: 'PCS运行状态', value: PcsRunSt.getText(pcs.pcs_run_st) },
    { key: 'p', label: '有功功率', value: pcs.p ?? '--', unit: 'kW' },
    { key: 'temp', label: '环境温度', value: pcs.temp_chassis ?? '--', unit: '℃' },
    { key: 'mode', label: 'PCS运行模式', value: PcsRunMode.getText(pcs.pcs_run_mode) },
    { key: 'q', label: '无功功率', value: pcs.q ?? '--', unit: 'kVar' },
    { key: 'chassisTemp', label: '机箱内温度', value: pcs.temp_chassis ?? '--', unit: '℃' },
    { key: 'insulation', label: '对地绝缘阻抗', value: eBlock.r_insulation ?? '--', unit: 'KΩ' }
  ]
})




let batteryClusterIndex = ref(0)
const batteryClusterEBlockId = computed(() => props.eLink?.eBlocks?.at(batteryClusterIndex.value)?.id)

function onBatteryClusterTabClick(tab, index) {
  activeBatteryTab.value = tab

  // 设置当前电池簇索引
  batteryClusterIndex.value = index
}

// 监听电池簇ID变化，重新开始轮询
watch(() => batteryClusterEBlockId.value, (eblockId, _, onCleanup) => {
  if (eblockId) {
    batteryClusterStart()
    onCleanup(() => {
      batteryClusterStop()
    })
  }
})

const { realData: batteryClusterRealData, start: batteryClusterStart, stop: batteryClusterStop, updateOnce: batteryClusterUpdateOnce } = useRealData({
  interval: 2000,
  initData: [],
  immediate: false,
  updateFunction: () => {
    return ws_req.request('ws_eblock_detail', {
      eBlockId: batteryClusterEBlockId.value,
      stationId: props.stationId
    })
  },
  onUpdate: (data) => {
    console.log('ws_eblock_detail--->', data);

  }
})


const batteryTabs = Array.from({ length: eBlocksLength.value }).map((_, index) => `${index + 1}#电池簇`)//['1#电池簇', '2#电池簇', '3#电池簇', '4#电池簇', '5#电池簇', '6#电池簇']
const activeBatteryTab = ref(batteryTabs[0])
const batteryItems = computed(() => {
  // const eBlock = realData.value?.eBlock || {}
  const eBlock = batteryClusterRealData.value?.data || {}
  const uCellMax = Number(eBlock.u_cell_max || 0)
  const uCellMin = Number(eBlock.u_cell_min || 0)
  const tempMax = Number(eBlock.temp_cell_max || 0)
  const tempMin = Number(eBlock.temp_cell_min || 0)
  const uDiff =
    eBlock.u_cell_diff !== undefined && eBlock.u_cell_diff !== null && eBlock.u_cell_diff !== ''
      ? Number(eBlock.u_cell_diff)
      : uCellMax - uCellMin
  const tDiff =
    eBlock.temp_cell_diff !== undefined && eBlock.temp_cell_diff !== null && eBlock.temp_cell_diff !== ''
      ? Number(eBlock.temp_cell_diff)
      : tempMax - tempMin

  return [
    { key: 'chMax', label: '允许最大充电功率', value: eBlock.p_ch_max ?? '--', unit: 'kW' },
    { key: 'dischMax', label: '允许最大放电功率', value: eBlock.p_disch_max ?? '--', unit: 'kW' },
    { key: 'uMax', label: '最高电芯电压', value: eBlock.u_cell_max ?? '--', unit: 'mV' },
    { key: 'uMin', label: '最低电芯电压', value: eBlock.u_cell_min ?? '--', unit: 'mV' },
    { key: 'uDiff', label: '电芯最高压差', value: toFixedDisplay(uDiff, 2, 'mV') },
    { key: 'tMax', label: '最高电芯温度', value: eBlock.temp_cell_max ?? '--', unit: '℃' },
    { key: 'tMin', label: '最低电芯温度', value: eBlock.temp_cell_min ?? '--', unit: '℃' },
    { key: 'tDiff', label: '电芯最高温差', value: toFixedDisplay(tDiff, 2, '℃') },
  ]
})

const fireItems = computed(() => {
  const fireSys = realData.value?.fire_sys || {}
  const eBlock = realData.value?.eBlock || {}
  const matrix = fireSys.matrix || {}
  const firstCabinet = Array.isArray(fireSys.cabinet) ? fireSys.cabinet[0] || {} : {}
  const sensorRaw = pickFirst(firstCabinet.smoke_alarm, firstCabinet.voc_alarm)

  return [
    { key: 'sensorSt', label: '传感器状态', value: sensorRaw === undefined ? '--' : FireSensorSt.getText(sensorRaw) },
    { key: 'hostOnline', label: '消防主机在线状态', value: FireHostOnlineSt.getText(matrix.offline) },
    { key: 'cabTemp', label: '柜体温度', value: pickFirst(firstCabinet.temp, eBlock.temp_cabinet, '--'), unit: '℃' },
    { key: 'co', label: 'CO浓度', value: pickFirst(firstCabinet.co_conc, '--'), unit: 'ppm' },
    { key: 'alarmLv', label: '柜体消防预警级别', value: FireSt.getText(matrix.alarm_level) },
    { key: 'hum', label: '柜体湿度', value: eBlock.hum_cabinet ?? '--', unit: '%' }
  ]
})

const airItems = computed(() => {
  const eBlock = realData.value?.eBlock || {}
  const eLink = realData.value?.eLink || {}
  const aircSt = pickFirst(eBlock.airc_st, eLink.airc_st)
  const onOff = aircSt === undefined ? '--' : Number(aircSt) === 0 ? '关机' : '开机'

  return [
    { key: 'onOff', label: '开关机状态', value: onOff },
    { key: 'airSt', label: '空调状态', value: AircSt.getText(aircSt) },
    { key: 'evapTemp', label: '空调蒸发器温度', value: eBlock.temp_evaporator ?? '--', unit: '℃' },
    { key: 'unitSt', label: '空调机组状态', value: AircSt.getText(aircSt) },
    { key: 'condTemp', label: '空调冷凝器温度', value: eBlock.temp_condenser ?? '--', unit: '℃' },
    { key: 'hum', label: '湿度', value: eBlock.hum_cabinet ?? '--', unit: '%' },
    { key: 'returnTemp', label: '回风温度', value: eBlock.temp_return ?? '--', unit: '℃' }
  ]
})

function onBack() {
  router.back()
}

function openElinkDetail() {
  eLinkDetailDialogVisible.value = true
}

function openPCSDetail() {
  currentPcsDetail.value = {
    ...props.galaxy,
    ...firstEBlock.value,
    uuid: eBlockDialogUuid.value,
    name: activePcsTab.value
  }
  pcsDetailDialogVisible.value = true
}

function openClusterDetail() {
  currentClusterDetail.value = {
    ...props.galaxy,
    ...firstEBlock.value,
    // id: firstEBlock.value?.id ?? props.galaxy?.id,
    code: (batteryClusterIndex.value + 1) + '#',
    name: activeBatteryTab.value,
    eblock_id: batteryClusterEBlockId.value,
  }
  clusterDetailDialogVisible.value = true
}

function openFireDetail() {
  currentBlock.value = {
    ...props.galaxy,
    ...firstEBlock.value,
    eblock_name: firstEBlock.value?.eBlockName || props.galaxy?.equipmentName || '--',
    pack: realData.value?.fire_sys?.pack || []
  }
  packDialogVisible.value = true
}

function openAirConditionDetail() {
  currentDetailElinkUuid.value = props.eLink?.uuid || realData.value?.eLink?.uuid || null
  currentDetailEblockUuid.value = eBlockDialogUuid.value
  openWithAlarmHistory.value = false
  airConditionDetailVisible.value = true
}

function onSideNavClick(item) {
  activeSection.value = item.key
  const target = document.getElementById(`data-section-${item.key}`)
  const pageEl = pageRef.value
  if (target && pageEl) {
    const pageRect = pageEl.getBoundingClientRect()
    const targetRect = target.getBoundingClientRect()
    const scrollTop = targetRect.top - pageRect.top + pageEl.scrollTop - 12
    pageEl.scrollTo({ top: scrollTop, behavior: 'smooth' })
  }
}

const pageRef = useTemplateRef('pageRef')
// const detailSectionsRef = useTemplateRef('detailSectionsRef')
const sectionElements = ref([])
let scrollRafId = 0

function updateActiveSectionByScroll() {
  const pageEl = pageRef.value
  if (!pageEl || !sectionElements.value.length) return

  const pageRect = pageEl.getBoundingClientRect()
  const currentTop = pageEl.scrollTop + 20
  let currentKey = sectionElements.value[0]?.key || activeSection.value

  for (const section of sectionElements.value) {
    const sectionTop = section.el.getBoundingClientRect().top - pageRect.top + pageEl.scrollTop
    if (sectionTop <= currentTop) {
      currentKey = section.key
    } else {
      break
    }
  }

  activeSection.value = currentKey
}

function onPageScroll() {
  if (scrollRafId) return
  scrollRafId = requestAnimationFrame(() => {
    scrollRafId = 0
    updateActiveSectionByScroll()
  })
}

onMounted(async () => {
  await nextTick()
  sectionElements.value = sideMenus
    .map(item => {
      const el = document.getElementById(`data-section-${item.key}`)
      return el ? { key: item.key, el } : null
    })
    .filter(Boolean)

  updateActiveSectionByScroll()
})

onBeforeUnmount(() => {
  if (scrollRafId) {
    cancelAnimationFrame(scrollRafId)
    scrollRafId = 0
  }
})


// 
const { realData, start, stop } = useRealData({
  interval: 2000,
  immediate: false,
  updateFunction: () => {
    return ws_req.request('galaxy_realtime_data', {
      stationId: props.stationId,
      galaxyId: props.galaxy.id
    })
  },
})

watch([() => props.galaxy.id, () => props.stationId], ([id, stationId], __, onCleanup) => {
  if (id && stationId) {
    start()
    onCleanup(() => {
      stop()
    })
  }
})





</script>

<style scoped lang="scss">
.galaxy-detail-page {
  flex: 1;
  min-width: 0;
  padding: 18px;
  background: #f7f9fc;
  border-radius: 20px;
  overflow-y: auto;
}

.overview-card {
  display: grid;
  // grid-template-columns: 400px 1fr;
  gap: 20px;
  padding: 18px 20px;
  border-radius: 20px;
  background: #fff;
  border: 1px solid #ecf1f8;
  margin-bottom: 16px;
}

.overview-left {
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-card {
  background: #fff;
  border-radius: 14px;
  padding: 2px 0 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  min-width: 0;
  display: flex;
  align-items: center;
}

.header-main {
  margin-left: 14px;
  min-width: 0;
}

.device-name {
  font-size: 20px;
  line-height: 36px;
  font-weight: 600;
  color: #1f2329;
  margin: 0 0 8px;
}

.meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  color: #747f92;
  font-size: 14px;
  line-height: 18px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 22px;
}

.status-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.device-image-wrap {
  width: 100%;
  height: 100%;
  min-height: 220px;
  border-radius: 12px;
  background: radial-gradient(60% 60% at 50% 58%, rgba(107, 136, 255, 0.08) 0%, rgba(255, 255, 255, 0) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.device-image {
  width: 90%;
  max-height: 260px;
  object-fit: contain;
}

.alarm-label {
  color: #1f2329;
  font-size: 14px;
}

.status-alarm {}

.status-alarm.is-normal {
  color: #19b45b;
  border: 1px solid #61b184 !important;
}

.status-alarm.is-alarm {
  color: #ff4d4f;
  border: 1px solid #ff4d4f !important;
}

.status-pill.online {
  color: #1d4ed8;
  border: 1px solid #9ab5ff !important;
}

.status-pill.offline {
  color: #6b7280;
  border: 1px solid #bbc8dd !important;
}

.overview-right {
  min-width: 0;
}

.overview-section {
  margin-top: 6px;
  border: none !important;
  border-radius: 0 !important;
  overflow: hidden;
}

.section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  color: #1f2329;
  font-weight: 500;
  background: #fff linear-gradient(109.37deg, rgba(231, 237, 255, 0.55) 1.53%, rgba(255, 255, 255, 0.6) 98.28%);
  padding: 8px 12px;
  border-bottom: 1px solid #eff3f9;
}

.section-title-left {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.overview-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
  margin-top: 16px;
}

.blue-bg {
  background: linear-gradient(132.97deg, #E7F3FF 1.64%, rgba(255, 255, 255, 0.7) 73.78%);
}

.red-bg {
  background: linear-gradient(132.97deg, #FFE7E7 1.64%, rgba(255, 255, 255, 0.7) 73.78%);
}

.green-bg {
  background: linear-gradient(132.97deg, #E7FFE7 1.64%, rgba(255, 255, 255, 0.7) 73.78%);
}

.blue-border {
  border: 1px solid #E7F3FF;
}

.red-border {
  border: 1px solid #FFE7E7;
}

.green-border {
  border: 1px solid #E4FAE2;
}

.content-card {
  margin-top: 14px;
  display: grid;
  grid-template-columns: 90px minmax(0, 1fr);
  gap: 14px;
}

.side-nav {
  background: #fff;
  border: 1px solid #ecf1f8;
  border-radius: 14px;
  padding: 10px 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: sticky;
  top: 0;
}

.side-nav-item {
  border-radius: 8px;
  min-height: 58px;
  background: #f6f9fc;
  color: #5f6b7b;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.side-nav-item.active {
  color: #3563ff;
  background: #edf3ff;
  box-shadow: inset 0 0 0 1px #dce8ff;
}

.detail-sections {
  min-width: 0;
  display: grid;
  gap: 12px;
}

.data-section {
  border-radius: 16px;
  border: 1px solid #edf2f8;
  background: #fff;
  overflow: hidden;
}

.section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-bottom: 1px solid #eff3f9;
  background: #fff linear-gradient(109.37deg, rgba(231, 237, 255, 0.55) 1.53%, rgba(255, 255, 255, 0.6) 98.28%);
}

.section-head-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  color: #1f2329;
}

.section-more-btn {
  border: none;
  background: transparent;
  color: #4c7eff;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 14px;
  line-height: 18px;
  cursor: pointer;
}

.tabs {
  padding: 12px 12px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tab {
  border: 1px solid #deebff;
  border-radius: 14px;
  background: #f5f8ff;
  color: #6c7a91;
  padding: 2px 10px;
  font-size: 13px;
  cursor: pointer;
}

.tab.active {
  color: #fff;
  background: #3563ff;
  border-color: #3563ff;
}



.section-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px 12px;
  padding: 12px;
}

.kv-bg {
  background: #f6f9fc;
}

@media (max-width: 1600px) {
  .overview-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 1366px) {
  .overview-card {
    grid-template-columns: 1fr;
  }

  .overview-left {
    display: none;
  }

  .section-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 1280px) {
  .content-card {
    grid-template-columns: 1fr;
  }

  .side-nav {
    flex-direction: row;
    overflow-x: auto;
  }

  .side-nav-item {
    min-width: 86px;
  }
}
</style>
